import { ChallengeShippingAddress } from '../../../types/challenges';
import { instagramUsernameRegex } from '../../../utils/constants';
import { getAddressLineOneError, isAddressLineOneValid, isValidEmail } from '../../../utils/validations';

export type ApplicationPersonalDetails = {
  name: string;
  email: string;
  instagramUsername: string;
};

export type ApplicationShippingAddress = Required<Omit<ChallengeShippingAddress, 'phone'>>;

export type ApplicationFieldName = keyof ApplicationPersonalDetails | keyof ApplicationShippingAddress;

export type ApplicationErrors = Partial<Record<ApplicationFieldName, string>>;

export const initialPersonalDetails: ApplicationPersonalDetails = { name: '', email: '', instagramUsername: '' };

export const initialShippingAddress: ApplicationShippingAddress = {
  addressLineOne: '',
  addressLineTwo: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
};

export const normalizeInstagramUsername = (username: string) => username.trim().replace(/^@/, '');

export const validateApplication = (details: ApplicationPersonalDetails, address: ApplicationShippingAddress) => {
  const errors: ApplicationErrors = {};
  const instagramUsername = normalizeInstagramUsername(details.instagramUsername);
  const addressLineOne = address.addressLineOne.trim();

  if (!details.name.trim()) errors.name = 'Name is required';

  if (!details.email.trim()) errors.email = 'Email is required';
  else if (!isValidEmail(details.email)) errors.email = 'Enter a valid email';

  if (!instagramUsername) errors.instagramUsername = 'Instagram handle is required';
  else if (!instagramUsernameRegex.test(instagramUsername)) errors.instagramUsername = 'Enter a valid Instagram handle';

  if (!addressLineOne) errors.addressLineOne = 'Address is required';
  else if (!isAddressLineOneValid(addressLineOne)) errors.addressLineOne = getAddressLineOneError(addressLineOne);

  if (!address.pincode.trim()) errors.pincode = 'Postal code is required';
  if (!address.city.trim()) errors.city = 'City is required';
  if (!address.state.trim()) errors.state = 'State is required';
  if (!address.country.trim()) errors.country = 'Country is required';

  return errors;
};
